import React, { useMemo } from 'react';

import { IGetChargingPointsByIdResponse, MConnector } from 'models/http/chargingPoint';
import { ConnectorStatus } from 'utils/enums/chargingType';
import { GroupedConnectors } from './ChargingPointPopup.model';
import ChargingPointPopupView from './ChargingPointPopup.view';

type Props = {
  chargingPoint: IGetChargingPointsByIdResponse | null;
};

const ChargingPointPopup: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  const groupOfconnectors: GroupedConnectors[] | undefined = useMemo(() => {
    return props.chargingPoint?.connectors.reduce((acc: GroupedConnectors[], curr: MConnector) => {
      const connector = acc.find((connector: GroupedConnectors) => connector.type === curr.connectorType);

      if (connector) {
        if (curr.status === ConnectorStatus.Free) {
          connector.available += 1;
        }

        connector.total += 1;
      } else {
        return [
          ...acc,
          {
            type: curr.connectorType,
            available: curr.status === ConnectorStatus.Free ? 1 : 0,
            total: 1,
            maxVoltage: curr.maxVoltage,
            status: curr.status
          },
        ];
      }

      return acc;
    }, []);
  }, [props.chargingPoint]);

  return (
    <ChargingPointPopupView
      name={props.chargingPoint?.name}
      address={props.chargingPoint?.address.name}
      operatorName={props.chargingPoint?.operator?.name}
      updateAt={props.chargingPoint?.updateAt}
      groupOfconnectors={groupOfconnectors}
    >
      {props.children}
    </ChargingPointPopupView>
  );
};

ChargingPointPopup.displayName = 'ChargingPointPopup';
ChargingPointPopup.defaultProps = {};

export default ChargingPointPopup;
